module.exports = __webpack_public_path__ + "static/one-percent-swiper_img01-0ee18618271531db9567eef864dbf66b.jpg";